import { useEffect, useState } from "react";
import { ArrowIcon } from "../../../assets/icons";
import { Button } from "../../../components/button/button";
import { Image } from "../../../components/image/image";
import { useOpenPage } from "../../../hooks/useOpenPage";

import styles from "./knowledgeBasePage.module.css";
import KnowledgeAPI from "../../../api/KnowledgeAPI";

import { Text } from "../../../components/text/text";

export const KnowledgeButton = ({ text, imgSrc, link }) => {
    const openPage = useOpenPage();

    const [photo, setPhoto] = useState(null);
    useEffect(() => {
        if (!imgSrc) return;
        KnowledgeAPI
            .fetchMaterialIconURL(imgSrc)
            .then(setPhoto)
            .catch(console.error);
    }, [imgSrc]);

    return (
        <Button
            onClick={openPage(link)}
            text={
                <div className={styles.line_style}>
                    {
                        imgSrc &&
                        <Image width="24px" height="30px" src={photo} className={styles.image} />
                    }
                    <Text as="span" variant="body" className={styles.text_style} size={14} weight={700} lineHeight="1.1">{text}</Text>
                </div>}
            icon={<ArrowIcon />}
            type="secondary"
        />
    )
}